import React from 'react';
import cn from 'classnames';
import styles from './Legend.module.scss';

const getContent = (item) => {
  return `${item.name} — ${item.value} (${item.percent}%)`;
};

const Legend = ({
  data = [],
  onItemClick,
  isActiveItem,
  colors,
  renderContent,
}) => {
  return (
    <div className={styles.root}>
      {data.map((item, index) => {
        const isClickable = typeof onItemClick === 'function' && item.value > 0;
        return (
          <div
            key={typeof renderContent === 'function' ? item.id : item.name}
            className={styles.item}
            style={isClickable ? { cursor: 'pointer' } : {}}
            onClick={isClickable ? () => onItemClick(item) : undefined}
          >
            <div
              className={styles.circle}
              style={{ background: colors[index % colors.length] }}
            />
            <div
              className={cn(styles.name, {
                [styles.active]:
                  typeof isActiveItem === 'function' && isActiveItem(item),
              })}
            >
              {typeof renderContent === 'function'
                ? renderContent(item)
                : getContent(item)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Legend;
